import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=df656082&scoped=true"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"
import style0 from "./PolicyForm.vue?vue&type=style&index=0&id=df656082&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df656082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df656082')) {
      api.createRecord('df656082', component.options)
    } else {
      api.reload('df656082', component.options)
    }
    module.hot.accept("./PolicyForm.vue?vue&type=template&id=df656082&scoped=true", function () {
      api.rerender('df656082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/PolicyForm.vue"
export default component.exports